import { useEffect, useState } from 'react';
import { numberOnly, onlyEnglish } from '../../../../application/helper/utilities';
import {
  Wrapper,
  InputWrapper,
  Icon,
  Input,
  InputLabel,
  PasswordButton
} from './styled';

function InputGroup(props) {
  const [inputType, setInputType] = useState(props.type);
  const [inputValue, setInputValue] = useState(props.value);
 
  function togglePasswordType(){
    setInputType(inputType === 'password' ? 'text' : 'password');
  }

  function renderInputValue(type, value){
    switch (type){
      case 'tel':
        return numberOnly(value);

      case 'english':
        return onlyEnglish(value);

      default:
        return value;
    }
  }

  function updateInputValueState(value){
    const { type } = props;
    const checkType = props.onlyEnglish ? 'english' : type;
    const renderValue = renderInputValue(checkType, value);
    setInputValue(renderValue);

    return renderValue;
  }

  useEffect(() => {
    if (props.clearValue){
      updateInputValueState('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  useEffect(() => {
    if (props.value && inputValue !== `${props.value}`){
      setInputValue(`${props.value}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleChange(e){
    const { value } = e.target;

    // const checkType = props.onlyEnglish ? 'english' : type;
    const renderValue = updateInputValueState(value);
    const inputEvent = {
      ...e,
      value: renderValue,
      name: props.name
    };

    if (props.onChange){
      return props.onChange(inputEvent);
    }

    return e;
  }
  
  const inputID = props.id || props.name;

  return (
    <Wrapper>
      <InputWrapper>
        { props.icon && <Icon>{props.icon}</Icon> }
          <Input
            {...props}
            id={inputID}
            name={props.name}
            type={inputType}
            placeholder={props.placeholder}
            value={inputValue}
            onClick={props.onClick}
            onChange={e => handleChange(e)}
            required={!!props.required}
            disabled={props.disabled}
            autoComplete={props.autoComplete}
            autoFocus={props.autoFocus}
            min={props.min}
            max={props.max}
            minLength={props.minLength}
            maxLength={props.maxLength}
            withIcon={props.icon}
            withPassword={props.type === 'password'}
          />
          {props.label &&

          <InputLabel
              htmlFor={inputID}
              required={!!props.required}
              withLeftIcon={props.icon}
            >
              {props.label}
            </InputLabel>
          }

          {props.type === 'password' &&
            <PasswordButton
              type="button"
              title="view password"
              onClick={() => togglePasswordType()}
              active={inputType === 'text'}
              disabled={props.disabled}
            >
            </PasswordButton>
          }
          
      </InputWrapper>
    </Wrapper>
  )
}

export default InputGroup;